var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .usdc-cls-1 {\n        fill: #2775ca;\n      }\n\n      .usdc-cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "usdc-cls-1",
    d: "M32,64A32,32,0,1,0,0,32,31.93,31.93,0,0,0,32,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "usdc-cls-2",
    d: "M40.93,36.73c0-4.66-2.8-6.26-8.4-6.93-4-.53-4.8-1.6-4.8-3.47s1.34-3.06,4-3.06c2.4,0,3.74.8,4.4,2.8a1,1,0,0,0,.94.66H39.2a.91.91,0,0,0,.93-.93v-.13a6.65,6.65,0,0,0-6-5.47V17c0-.53-.4-.93-1.06-1.07h-2c-.54,0-.94.4-1.07,1.07v3.07c-4,.53-6.53,3.2-6.53,6.53,0,4.4,2.66,6.13,8.26,6.8,3.74.67,4.94,1.47,4.94,3.6s-1.87,3.6-4.4,3.6c-3.47,0-4.67-1.47-5.07-3.47a1,1,0,0,0-.93-.8H24a.91.91,0,0,0-.93.94v.13c.53,3.33,2.66,5.73,7.06,6.4V47c0,.53.4.93,1.07,1.07h2c.53,0,.93-.4,1.07-1.07V43.8c4-.67,6.66-3.47,6.66-7.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "usdc-cls-2",
    d: "M25.2,50.67a20,20,0,0,1,0-37.47,1.35,1.35,0,0,0,.8-1.33V10a1,1,0,0,0-.8-1.07.76.76,0,0,0-.53.14,24,24,0,0,0,0,45.73.81.81,0,0,0,1.2-.53c.13-.14.13-.27.13-.54V51.87A1.76,1.76,0,0,0,25.2,50.67ZM39.33,9.07a.81.81,0,0,0-1.2.53c-.13.13-.13.27-.13.53V12a1.76,1.76,0,0,0,.8,1.33,20,20,0,0,1,0,37.47,1.35,1.35,0,0,0-.8,1.33V54a1,1,0,0,0,.8,1.07.76.76,0,0,0,.53-.14,24.09,24.09,0,0,0,0-45.86Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.7634a322.svg";
export { ForwardRef as ReactComponent };